import { usePlaybackCurrentTs } from '@app/core/playback/hooks/usePlayback';
import { TimeRange } from '@mi-front/core';
import { Box } from '@mui/material';
import { tsToPercent } from './ts-to-percent';

type FocusTracksPlayheadProps = {
  range: TimeRange<number>;
};

/**
 * Single playhead line spanning the whole focus-tracks container (v2 NlePlayhead foreshadow).
 * Hidden when playback is outside the current focus range.
 */
export function FocusTracksPlayhead({ range }: FocusTracksPlayheadProps) {
  const currentTs = usePlaybackCurrentTs();

  if (!currentTs || currentTs < range.from || currentTs > range.to) {
    return null;
  }

  return (
    <Box
      data-testid="focus-tracks-playhead"
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: `${tsToPercent(currentTs, range)}%`,
        width: 0,
        pointerEvents: 'none',
        zIndex: 30,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: '-1px',
          width: '2px',
          bgcolor: 'error.main',
          opacity: 0.45,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: '-4px',
          width: 0,
          height: 0,
          borderLeft: '4px solid transparent',
          borderRight: '4px solid transparent',
          borderTop: '5px solid',
          borderTopColor: 'error.main',
          opacity: 0.45,
        }}
      />
    </Box>
  );
}
